<template>
  <div class="container text-center">
    <div class="head-title pb-0">
      <h2 class="text-uppercase text-black">Continent Map</h2>
    </div>
    <div class="back-btn mt-0">
      <router-link to="/dashboard">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </router-link>
    </div>
    <div class="map-wrapper">
      <div class="markLocation posLeft">
        <a
          href="JavaScript:void(0)"
          class="toolTipInHover"
          data-tip="North America"
          tabindex="1"
          @click.prevent="locationHit('North America')"
        >
          <img src="images/vector.png" alt="" />
        </a>
      </div>
      <div class="markLocation">
        <a
          href="JavaScript:void(0)"
          class="toolTipInHover"
          data-tip="South America"
          tabindex="2"
          @click.prevent="locationHit('South America')"
        >
          <img src="images/vector.png" alt="" />
        </a>
      </div>
      <div class="markLocation">
        <a
          href="JavaScript:void(0)"
          class="toolTipInHover"
          data-tip="Europe"
          tabindex="3"
          @click.prevent="locationHit('Europe')"
        >
          <img src="images/vector.png" alt="" />
        </a>
      </div>
      <div class="markLocation">
        <a
          href="JavaScript:void(0)"
          class="toolTipInHover"
          data-tip="Africa"
          tabindex="4"
          @click.prevent="locationHit('Africa')"
        >
          <img src="images/vector.png" alt="" />
        </a>
      </div>
      <div class="markLocation">
        <a
          href="JavaScript:void(0)"
          class="toolTipInHover"
          data-tip="Asia"
          tabindex="5"
          @click.prevent="locationHit('Asia')"
        >
          <img src="images/vector.png" alt="" />
        </a>
      </div>
      <div class="markLocation">
        <a
          href="JavaScript:void(0)"
          class="toolTipInHover"
          data-tip="Oceanic"
          tabindex="6"
          @click.prevent="locationHit('Australia')"
        >
          <img src="images/vector.png" alt="" />
        </a>
      </div>
    </div>
    <footer class="footer">
      <div class="d-flex justify-content-between align-items-center">
        <div class="content d-flex align-items-center">
          <div class="">
            <img src="images/map-1.png" alt="" />
          </div>
          <div class="txtBlock mt-2">
            <h1 class="txtBlock-title">Continent Name:{{ continentName }}</h1>
            <h2 class="text-left txtBlock-title-1">
              Distance:{{ knot }}
              <small class="text-danger"
                >Food required:{{ required_food }}</small
              >
            </h2>
            <!-- <small class="text-left">Allowed Ships:{{ ships }}</small> -->
          </div>
        </div>
        <div class="button">
          <router-link to="/discover" class="btn">Ready</router-link>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import ApiService from "../services";
export default {
  name: "Continent",
  data() {
    return {
      Loading: true,
      knot: 0,
      info: null,
      required_food: null,
      ships: "",
      continentName: "",
    };
  },
  mounted() {
    this.Loading = true;
    this.isLoading = true;
    ApiService.getAttack((res) => {
      this.isLoading = false;
      if (res !== false) {
        this.$router.push("waiting");
      } else {
        this.getDistance();
      }
    }).catch(() => this.getDistance());
  },
  methods: {
    getDistance() {
      ApiService.getTable(
        "distance",
        null,
        async (result) => {
          if (result.rows.length > 0) {
            this.info = result.rows;
            this.Loading = false;
          }
        },
        (error) => {
          this.Loading = false;
          console.log(error);
        }
      );
    },
    locationHit(loc) {
      localStorage.setItem("location", loc);
      this.continentName = loc;
      this.knot = this.info.filter((item) => item.location == loc)[0].knot;
      this.required_food = this.info.filter(
        (item) => item.location == loc
      )[0].req_food;
      this.ships = this.info.filter(
        (item) => item.location == loc
      )[0].allowed_ships;
    },
  },
};
</script>

<style scoped>
.back-btn {
  margin-top: 0 !important;
}
.button .btn {
  background: #fff;
  color: black;
  text-transform: uppercase;
  font-size: 2rem;
  font-weight: bold;
  border-radius: 15px;
  letter-spacing: 1px;
  padding: 0.2rem 1rem;
}
footer {
  position: fixed;
  bottom: 40px;
  margin: 0 50px;
  left: 0;
  right: 0;
}
</style>